import {
  getLinkFromApi,
  getLinkListFromApi,
  isLocal,
  isCms,
} from '../../utility'

export const unpackDocuments = (documents = []) => {
  return documents.map((itemData) => {
    const imageUrl = itemData['image']?.['_meta']?.['mirror']?.['path']
    return {
      id: itemData['_meta']?.['id'],
      title: itemData['title'],
      subtitle: itemData['subtitle'],
      time: itemData['time'],
      html: itemData['html']?.content,
      imageUrl: imageUrl
        ? `${isLocal() || isCms() ? '/site' : ''}/binaries/${imageUrl}`
        : '',
      link: getLinkFromApi(itemData['LinkCompound']),
      linkList: getLinkListFromApi(
        itemData['LinkList']?.links?.filter((l) => l.Link && l.Link.length > 0)
      ),
      imageId: itemData['image']?.['_meta']?.['mirror']?.['id'],
      videoId: itemData['videoId'],
      itemType: itemData['itemType'],
    }
  })
}

// Uses fields on CTI Blog Article Summary documents
export const unpackAdvisorDocuments = (documents = []) => {
  return documents.map((itemData) => {
    const imageUrl = itemData['image']?.['_meta']?.['mirror']?.['path']

    return {
      id: itemData._meta?.id,
      authors: itemData.author || itemData.authors,
      bannerSummary: itemData.bannerSummary,
      cardSummary: itemData.cardSummary,
      date: itemData.date,
      detailDocument: itemData.detailDocument,
      imageId: itemData.image?._meta?.mirror?.id,
      imageUrl: imageUrl
        ? `${isLocal() || isCms() ? '/site' : ''}/binaries/${imageUrl}`
        : '',
      linkList: getLinkListFromApi(
        itemData['links']?.links?.filter((l) => l.Link && l.Link.length > 0)
      ),
      time: itemData['time'],
      title: itemData.title,
      types: itemData.types,
    }
  })
}
